import { render } from "./AdministratorAddressList.vue?vue&type=template&id=39c7bcae"
import script from "./AdministratorAddressList.vue?vue&type=script&lang=js"
export * from "./AdministratorAddressList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/administrators/address/AdministratorAddressList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39c7bcae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39c7bcae', __exports__)) {
    api.reload('39c7bcae', __exports__)
  }
  
  module.hot.accept("./AdministratorAddressList.vue?vue&type=template&id=39c7bcae", () => {
    api.rerender('39c7bcae', render)
  })

}


export default __exports__